
import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next'
import { t } from 'i18next'
import { useLazyQuery } from '@apollo/client';
import { GET_BOAT_TYPE } from 'graphql/boat/queries';



export function BoatTypeDropdown({ value, onChange, onBlur, error, helperText }) {

  console.log("BoatTypeDropdown Value ===", value)
  const [boatTypeList, setBoatTypeList] = useState(null)

  const [getBoatTypeList, { loading: typeListLoading, error: typeListError }] = useLazyQuery(GET_BOAT_TYPE, {
    fetchPolicy: 'network-only',
    notifyOnNetworkStatusChange: true,
    onCompleted: data => {
      if (data.boatType.length > 0) {
        setBoatTypeList(data.boatType)
      }
    },
  })

  // get Type List
  const getBoatTypes = () => {
    getBoatTypeList({
      variables: {
        "code": null
      },
    })
  }
  useEffect(() => {
    getBoatTypes();
  }, [boatTypeList]);

  return (
    <>
      {typeListLoading && <div className="flex justify-center items-center bg-white py-5">Loading ....</div>}
      {typeListError && (
        <select>
          <option value={null}>{t('No data found')}</option>
        </select>
      )}
      {!typeListLoading && !typeListError && boatTypeList?.length === 0 && (
        <select>
          <option value={null}>{t('No data found')}</option>
        </select>
      )}
      {!typeListLoading && !typeListError && boatTypeList?.length > 0 && (
        <select
          id="boat_type"
          name="boat_type"
          onChange={onChange}
          onBlur={onBlur}
          value={value}
          className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm sm:leading-6"
        >
          <option value="" disabled> {t('Select Boat Type')} </option>
          {boatTypeList.map((boatType) => (
            <option key={boatType.code} value={boatType.code}>
              {boatType.description.en}
            </option>
          ))}
        </select>

      )}
      {error && <p className="text-error text-xs mt-1">
        {helperText}
      </p>}


    </>
  );


}
